module.exports = __webpack_public_path__ + "87649cbc3b47a48c84ef14740d312a6f.png";